import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Select, Button, Input, Icon } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { titles } from '@pages/GeneralRequest/Utils/settings'
import { commissions } from '@services/api'
import { subNames, isNumber } from '@utils/index'
import {
    editReportSubSelect, selectAntSub, editReportPriceWrapper, editReportPriceInput, editReportPriceCol, editReportAgentId, editReportIcon, editReportAgentName, editMentorRow, errorSub
} from './style.scss'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class EditCommissionRow extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            id: null,
            commission: null,
            price: null,
            comment: null,
            //
            agent_name: null,
            agent_id: null,
            agent_search_id: null,
            //
            mentor: null,
            //
            loading: false,
            sub_error: false,
            //
            heb_class: null,
            product_title: null,
            sub_name: null,
            subscription_id: null,
            products: [],
            //
            isOneTime: false
        }
    }

    componentDidMount(): void {
        const {
            data: { id, sub_name, price }
        } = this.props
        this.setState({ id })
        if (sub_name === 'עמלה חד פעמית') {
            this.setState({ sub_name, isOneTime: true, price })
        }
    }

    closePopup = reload => {
        const {
            popupStore: { togglePopup },
            events
        } = this.props
        events.setState({ editData: null, editRow: '', loading: false }, () => {
            if (typeof reload === 'boolean') events.getCommissionRows(events.state.current, true)
            togglePopup('')
        })
    }

    onTextArea = (event, key) => this.setState({ [key]: event.value })
    handleMentorSelect = (selectedMentor: string) => this.setState({ mentor: selectedMentor })
    handleProductSelect = (data: string) => {
        const { product_name, heb_class, products } = JSON.parse(data)
        this.setState({
            products,
            heb_class,
            product_title: product_name,
            sub_name: null,
            subscription_id: null,
            sub_error: false
        })
    }
    handleSubscriptionSelect = (data: string) => {
        const { subscription_id, name, price } = JSON.parse(data)
        this.setState({ sub_name: name, subscription_id, price, sub_error: false })
    }
    onAgentSearch = (event, key) => {
        this.setState({ [key]: event.value.replace(/[^0-9]/g, '') }, () => {
            if (!this.state.agent_search_id) this.setState({ agent_name: null, agent_id: null, mentor: null })
            if (this.state.agent_search_id && event.value.replace(/[^0-9]/g, ''))
                commissions
                    .findUserForCommission({ id: this.state.agent_search_id, isAgent: true })
                    .then(({ data, status }) => {
                        // prettier-ignore
                        if (status === 200) return this.setState({ agent_name: data.name, agent_id: data.id, mentor: data.mentor })
                        if (status === 201) return this.setState({ agent_name: data.name, agent_id: null })
                    })
                    .catch(() => alert('אירעה שגיאה'))
        })
    }
    editSave = () => {
        const { product_title, subscription_id } = this.state
        if (product_title && !subscription_id) return this.setState({ sub_error: true })
        this.setState({ loading: true })
        commissions
            .editCommissionRow(this.state)
            .then(() => this.closePopup(true))
            .catch(() => alert('אירעה שגיאה'))
    }

    render() {
        const {
            popupStore: { popupType },
            data,
            events
        } = this.props
        // prettier-ignore
        const { commission, price, comment, loading, mentor, agent_search_id, agent_name, sub_name, product_title, products, agent_id, sub_error, isOneTime } = this.state
        // prettier-ignore
        const { closePopup, onTextArea, editSave, handleMentorSelect, onAgentSearch, handleProductSelect, handleSubscriptionSelect } = this
        // prettier-ignore
        const { onNumberInput, state: { mentors, productList } } = events
        const btnInner = loading ? <Icon type="loading" /> : titles.confirm
        const mentorTitle = mentor || data.mentor || 'בחרו מנטור'
        const prodTitle = subNames[product_title] || subNames[data.product_name] || 'בחרו מוצר'
        const subTitle = sub_name || data.subscription_name || 'בחרו מנוי'

        return (
            <Modal
                title={`עדכון עמלה`}
                visible={popupType === 'editCommissionRowPopup'}
                onCancel={closePopup}
                footer={null}
            >
                <div className={editReportSubSelect}>
                    <div>{'בחירת מוצר'}</div>
                    <Select
                        value={prodTitle}
                        onChange={handleProductSelect}
                        className={selectAntSub}
                        disabled={isOneTime}
                    >
                        {productList.map(item => (
                            <Select.Option key={item.product_name} value={JSON.stringify(item)}>
                                {subNames[item.product_name] || item.product_name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
                <div className={editReportSubSelect}>
                    <div>{isOneTime ? 'סוג עמלה' : 'בחירת מנוי'}</div>
                    <Select
                        value={subTitle}
                        onChange={handleSubscriptionSelect}
                        className={selectAntSub}
                        disabled={!!!product_title}
                    >
                        {products.map(item => (
                            <Select.Option
                                key={item.subscription_id}
                                value={JSON.stringify(item)}
                                className={selectAntSub}
                            >
                                {item.name}
                            </Select.Option>
                        ))}
                    </Select>
                    {sub_error && <div className={errorSub}>נא לבחור מנוי</div>}
                </div>
                <div className={editReportPriceWrapper}>
                    <div className={editReportPriceCol}>
                        <div>{'עלות'}</div>
                        <Input
                            placeholder={data.price}
                            className={`${editReportPriceInput}`}
                            value={price}
                            onInput={({ target }) => onNumberInput(target, 'price', this, /[^0-9\.-]/g)}
                            disabled={isOneTime}
                        />
                    </div>
                    <div className={editReportPriceCol}>
                        <div>{'שנתי'}</div>
                        <Input
                            placeholder={isNumber(price) ? price * 12 : data.yearly}
                            className={`${editReportPriceInput}`}
                            disabled={true}
                        />
                    </div>
                    <div className={editReportPriceCol}>
                        <div>{'עמלה'}</div>
                        <Input
                            placeholder={data.commission}
                            className={`${editReportPriceInput}`}
                            value={commission}
                            onInput={({ target }) => onNumberInput(target, 'commission', this, /[^0-9\.-]/g)}
                        />
                    </div>
                </div>
                <div className={editReportPriceWrapper}>
                    <div className={editReportAgentId}>
                        <div>{'מזהה סוכן'}</div>
                        <Input
                            placeholder={data.agent_id}
                            className={editReportPriceInput}
                            value={agent_search_id}
                            onInput={({ target }) => onAgentSearch(target, 'agent_search_id')}
                        />
                    </div>
                    <div className={editReportIcon}>
                        {agent_id ? <Icon type={'check'} style={{ color: 'green', marginTop: '20px' }} /> : ''}
                    </div>
                    <div className={editReportAgentName}>
                        <div>{'שם סוכן'}</div>
                        <Input placeholder={agent_name || data.agent_name} disabled={true} />
                    </div>
                </div>
                <div className={editMentorRow}>
                    <div>{'בחירת מנטור'}</div>
                    <Select value={mentorTitle} onChange={handleMentorSelect} style={{ width: '29%' }}>
                        {mentors.map(({ name }) => (
                            <Select.Option key={name} value={name}>
                                {name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
                <div>
                    <div>הערה</div>
                    <TextArea
                        rows={2}
                        placeholder={data.comment}
                        value={comment}
                        onInput={({ target }) => onTextArea(target, 'comment')}
                        className={editReportPriceInput}
                    />
                </div>
                <div style={{ margin: '30px 0 0 0' }}>
                    <Button type="primary" onClick={editSave}>
                        {btnInner}
                    </Button>
                    <Button onClick={closePopup}>ביטול</Button>
                </div>
            </Modal>
        )
    }
}
